import React, { useContext } from "react";
import { TextField, Box, Typography, Divider } from "@mui/material";
import { AnimalContext } from "context/animalContext";
import dateFormat from "utils/dateFormat";
// import typeElevageList from "constant/typeElevage";
import { LIST_ANIMAL_STATUS } from "constant/staticData/listEspeceCategory";
import StampComponent from "components/StampComponet";

const AnimalDetails = () => {
  const { animal, title } = useContext(AnimalContext);
  // const typeElevage = typeElevageList.find((i) => i.name === animal?.elevageType);

  /* const animalEtat = animal?.statut?.split("|").reduce((acc, item) => {
    const [key, value] = item.split("_");
    if (key && value && value !== "OK" && value !== "RAS") {
      let label = value;
      if (value === "VOL") {
        label = "VOLÉ";
      }
      if (key === "SAN" && value === "ALERTE") {
        label = "en Alerte Sanitaire";
      }
      acc[key.toLowerCase()] = label;
    }
    return acc;
  }, {});
  const animalEtatString = animalEtat ? `ANIMAL ${Object.values(animalEtat).join(" & ")}` : ""; */
  // console.log("sss", animalEtat);
  const alertLabels = {
    isAlertVol: "Vol Animal",
    isAlertMaladie: "Sanitaire",
    isAlertVaccination: "Vaccination",
  };

  const filteredAlerts = Object.fromEntries(
    Object.entries(animal).filter(
      ([key, value]) =>
        (key === "isAlertVol" || key === "isAlertMaladie" || key === "isAlertVaccination") &&
        value === true
    )
  );

  const animalAlertLabel = Object.keys(filteredAlerts)
    .filter((key) => animal[key])
    .map((key) => alertLabels[key])
    .join(" & ");

  return (
    <Box
      sx={{
        padding: 2,
        border: "1px solid #ccc",
        borderRadius: 2,
        margin: 2,
        position: "relative",
      }}
      style={{ backgroundColor: "white" }}
    >
      <Box textAlign="center">
        <Typography variant="h6">Fiche de l&apos;animal {title ?? ""}</Typography>
      </Box>
      <TextField
        label="Référence de l'Animal"
        name="refAnimal"
        value={animal?.refAnimal ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        label="Numéro Puce"
        name="puce"
        value={animal?.puce?.numero ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="nom"
        label="Nom de l'Animal"
        value={animal?.nom && animal.nom.trim() !== "" ? animal.nom : "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="sexe"
        label="Sexe"
        value={animal?.sexe === "FEMALE" ? "FEMELLE" : animal?.sexe}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="espece"
        label="Espece"
        value={animal?.espece?.nomCourant ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="race"
        label="Race"
        value={animal?.race?.nomCourant ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="poids"
        label="Poids"
        value={animal?.poids ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="taille"
        label="Taille"
        value={animal?.taille ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      {/* <TextField
        name="categorie"
        label="Categorie"
        value={animal?.especeCategory ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      /> */}
      {/* <TextField
        name="elevageType"
        label="Type d'élevage"
        value={(() => {
          if (typeElevage) {
            return Object.keys(typeElevage)?.length !== 0
              ? typeElevage?.label
              : animal?.elevageType ?? "Non renseigné";
          }
          return "Non renseigné";
        })()}
        fullWidth
        margin="normal"
        disabled
      /> */}
      <TextField
        name="robe"
        label="Robe"
        value={
          animal?.animalRobe && animal.animalRobe.name && animal.animalRobe.name.trim() !== ""
            ? animal.animalRobe.name
            : "Non renseigné"
        }
        fullWidth
        margin="normal"
        disabled
      />
      {/* <TextField
        name="lot"
        label="Lot"
        value={
          animal?.lot?.nomLot && animal.lot?.nomLot.trim() !== ""
            ? animal.lot?.nomLot
            : "Non renseigné"
        }
        fullWidth
        margin="normal"
        disabled
      /> */}
      <TextField
        name="ferme"
        label="Ferme"
        value={
          animal?.ferme?.nom && animal.ferme?.nom.trim() !== ""
            ? animal.ferme?.nom
            : "Non renseigné"
        }
        fullWidth
        margin="normal"
        disabled
      />

      <TextField
        name="dateNaissance"
        label="Date de naissance"
        value={dateFormat(new Date(animal?.dateNaissance)) ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="age"
        label="Age"
        value={animal?.age ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="dateInsert"
        label="Date de création"
        value={dateFormat(new Date(animal?.dateInsert)) ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="projet"
        label="Projet"
        value={
          animal?.animalTags && animal?.animalTags.length > 0
            ? animal?.animalTags?.map((i) => i.tag?.name).join(", ") || ""
            : "Non renseigné"
        }
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="isTranshumance"
        label="Animal Transhumant ?"
        value={animal?.isTranshumance ? "Oui" : "Non"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="isAlertVol"
        label="Animal en alerte vol  ?"
        value={animal?.isAlertVol ? "Oui" : "Non"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="isAlertMaladie"
        label="Animal en alerte Sanitaire ?"
        value={animal?.isAlertMaladie ? "Oui" : "Non"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="isAlertVaccination"
        label="Animal en alerte vaccination ?"
        value={animal?.isAlertVaccination ? "Oui" : "Non"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        name="animalStatus"
        label="Statut"
        value={
          LIST_ANIMAL_STATUS.find((item) => item.value === animal?.animalStatus)?.label ??
          "Non renseigné"
        }
        fullWidth
        margin="normal"
        disabled
      />
      {/* <TextField
        name="statut"
        label="Etat"
        value={animal?.statut ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      /> */}
      <TextField
        name="observation"
        label="Observation"
        value={animal?.observation ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <Divider textAlign="center" />
      <Box textAlign="center">
        <Typography variant="h6">Lieu d&apos;Identification</Typography>
      </Box>

      <TextField
        label="Sous Préfecture"
        name="commune"
        value={animal?.lieuIdentification?.commune ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        label="Préfecture"
        name="departement"
        value={animal?.lieuIdentification?.departement ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      <TextField
        label="Région"
        name="region"
        value={animal?.lieuIdentification?.region ?? "Non renseigné"}
        fullWidth
        margin="normal"
        disabled
      />
      {/* animal?.statut && animal?.statut !== "" && <StampComponent label={animalEtatString} /> */}
      {animalAlertLabel && <StampComponent label={animalAlertLabel} />}
    </Box>
  );
};

export default AnimalDetails;
